export class IdentityFormAPI {
    /**
     * Send email containing OTP token
     *
     * @param data
     */
    public static async sendOTPToken(data: any) {
        const csrfTokenInputElement = document.querySelector('[name=csrfmiddlewaretoken]') as HTMLInputElement
        const csrfToken = (csrfTokenInputElement) ? csrfTokenInputElement.value : ''
        const sendOTPTokenCall = await fetch('/api-root/subscription/identity/request_passwordless_otp/', {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken
            },
            method: 'POST',
            mode: 'same-origin'
        })

        return await sendOTPTokenCall.json()
    }

    /**
     * Verify OTP passwordless token
     *
     * @param data
     */
    public static async verifyPasswordlessOTP(data: any) {
        const csrfTokenInputElement = document.querySelector('[name=csrfmiddlewaretoken]') as HTMLInputElement
        const csrfToken = (csrfTokenInputElement) ? csrfTokenInputElement.value : ''

        const verifyOTPTokenCall = await fetch('/api-root/subscription/identity/verify_passwordless_otp/', {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken
            },
            method: 'POST',
            mode: 'same-origin'
        })

        return await verifyOTPTokenCall.json()
    }
}
